import { IQueryConditionHandler } from './iquerycondition.handler';
import { QueryCondition, DropDownListValue } from '@farris/component-querycondition';
import { CompareType } from '../enum/compare-type.enum';
import { ValueType } from '../enum/value-type.enum';
import { RelationType } from '../enum/relation-type.enum';

export class DropDownHandler implements IQueryConditionHandler {
  // qc.comparetypeåªæç­äºãä¸ç­äº
  convert(qc: QueryCondition) {
    const ddv = (qc.value as DropDownListValue);
    const arr = [];
    ddv.value.forEach((dv) => {
      arr.push({
        'FilterField': qc.fieldCode,
        'Compare': (qc.compareType || qc.compareType === 0) ? qc.compareType : CompareType.Equal,
        'Value': dv.value,
        'Relation': qc.compareType === CompareType.NotEqual ? RelationType.And : RelationType.Or,
        'Expresstype': ValueType.Value
      });
    });
    arr[0]['Lbracket'] = qc.Lbracket ? (qc.Lbracket + '(') :'(';
    arr[arr.length -1]['Rbracket'] = qc.Rbracket ? (qc.Rbracket + ')') : ')';
    arr[arr.length - 1]['Relation'] = (qc.relation || qc.relation === 0) ? qc.relation : RelationType.And;
    return arr;
  }
}
